export default class Notes {
  createOn = ''
  fileSize = ''
  id = ''
  isDelete = ''
  isStar = ''
  middleUrl = ''
  noteId = ''
  noteName = ''
  ocrContent = ''
  ossBucket = ''
  pageNum = ''
  smallUrl = ''
  synchronousOn = ''
  tagId = ''
  tagName = ''
  updateOn = ''
  url = ''
  userId = ''
  uuid = ''
  selected = false
  name = ''
  fileId = ''
  groupId = ''
  incorrect = ''
  packageId = ''

  naturalWidth = 0
  naturalHeight = 0
  maxWidth = 180
  maxHeight = 180
  showWidth = 180
  showHeight = 180

  imageScale = 1

  loadData = function (jsonData) {
    this.createOn = jsonData.createOn
    this.fileSize = jsonData.fileSize
    this.id = jsonData.id
    this.isDelete = jsonData.isDelete
    this.isStar = jsonData.isStar
    this.middleUrl = jsonData.middleUrl
    this.noteId = jsonData.noteId
    this.noteName = jsonData.noteName
    this.ocrContent = jsonData.ocrContent
    this.ossBucket = jsonData.ossBucket
    this.pageNum = jsonData.pageNum
    this.smallUrl = jsonData.smallUrl
    this.synchronousOn = jsonData.synchronousOn
    this.tagId = jsonData.tagId
    this.tagName = jsonData.tagName
    this.updateOn = jsonData.updateOn
    this.url = jsonData.url
    this.userId = jsonData.userId
    this.uuid = jsonData.uuid
  }

  loadShareFolderData = function (jsonData) {
    this.id = jsonData.packageId
    this.name = jsonData.packageName
    this.smallUrl = jsonData.smallUrl
    this.userId = jsonData.userId
  }

  loadShareFileData = function (jsonData) {
    this.id = jsonData.id
    this.fileId = jsonData.fileId
    this.groupId = jsonData.groupId
    this.packageId = jsonData.packageId
    this.incorrect = jsonData.incorrect
    this.name = jsonData.packageName
    this.pageNum = jsonData.pageNum
    this.middleUrl = jsonData.middleUrl
    this.smallUrl = jsonData.smallUrl
    this.type = jsonData.type
    this.userId = jsonData.userId
  }

  isSameMiddle = function (imageSrc) {
    var isSame = false
    if (imageSrc === this.middleUrl) {
      isSame = true
    }
    return isSame
  }

  isSameSmall = function (imageSrc) {
    var isSame = false
    if (imageSrc === this.smallUrl) {
      isSame = true
    }
    return isSame
  }

  computeShowSize = function (width, height) {
    this.naturalWidth = width
    this.naturalHeight = height
    var scaleW = this.naturalWidth / this.maxWidth
    var scaleH = this.naturalHeight / this.maxHeight
    var scale = (scaleW > scaleH) ? scaleW : scaleH
    this.showWidth = this.naturalWidth / scale
    this.showHeight = this.naturalHeight / scale
  }
}



// WEBPACK FOOTER //
// ./src/common/model/Notes.js